module.exports = __webpack_public_path__ + "assets/img/icon8.d5cd9e6b.png";